import { refreshAccessToken } from "./apiClient";
import { API_URL } from "./constant";

// add orders
// export async function addOrders(data){
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         console.log(data.is_same_asowner)
//         const response = await fetch(`${API_URL}/orders/`,{
//             method:'POST',
//             headers:{
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(data)
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error('Order creation failed');
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;
//     }catch(error){
//         console.log("error on creating orders",error?.data || error.message)
//         throw error;
//     }
// }

// Internal helper
async function attemptAddOrder(data, token) {
  const response = await fetch(`${API_URL}/orders/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(data)
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error('Order creation failed');
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// Main function
export async function addOrders(data) {
  let accessToken = JSON.parse(localStorage.getItem('accessToken'));

  try {
    return await attemptAddOrder(data, accessToken);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        return await attemptAddOrder(data, newAccessToken);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError.message);
        throw refreshError;
      }
    }

    console.log("error on creating orders", error?.data || error.message);
    throw error;
  }
}


// list orders
// export async function orderList(page=1, size=10) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))
//         const response = await fetch(`${API_URL}/orders/?page=${page}&page_size=${size}`,{
//             method:'GET',
//             headers:{
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${parsedToken}`,
//             }
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error('Failed to fetch order list');
//                 err.data = responseData;
//                 err.status = response.status;
//                 throw err;
//         }

//         return responseData;
//     }catch(error){
//         console.log("error while getting list of orders", error?.data || error.message)
//         throw error;
//     }    
// }

// Internal helper
async function attemptGetOrderList(page, size, token,statusFilter,searchTerm,productFilter) {

  const params = new URLSearchParams({
    page,
    page_size : size,
  });

  if (statusFilter) params.append('status', statusFilter);
  if (productFilter) params.append('product', productFilter);
  if (searchTerm) params.append('search',searchTerm);

  // const response = await fetch(`${API_URL}/orders/?page=${page}&page_size=${size}&status=${statusFilter}`, {
  //   method: 'GET',
  //   headers: {
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${token}`,
  //   }
  // });

  const response = await fetch(`${API_URL}/orders/?${params.toString()}`,{
    method: 'GET',
    headers: {
      'Content-Type' : 'application/json',
      'Authorization': `Bearer ${token}`,
    }
  })

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error('Failed to fetch order list');
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// Main function
export async function orderList(page = 1, size = 10,statusFilter,searchTerm,productFilter) {
  let accessToken = JSON.parse(localStorage.getItem('accessToken'));

  try {
    return await attemptGetOrderList(page, size, accessToken,statusFilter,searchTerm,productFilter);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        return await attemptGetOrderList(page, size, newAccessToken, statusFilter, searchTerm,productFilter);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError.message);
        throw refreshError;
      }
    }

    console.log("error while getting list of orders", error?.data || error.message);
    throw error;
  }
}


// edit orders
// export async function editOrder(data) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const orderEditData = {};
//         if (data.file_num) orderEditData.file_num = data.file_num;
//         if  (data.loan_number) orderEditData.loan_number = data.loan_number;
//         if (data.client_name) orderEditData.client_name = data.client_name;
//         if  (data.lender_contact) orderEditData.lender_contact = data.lender_contact;
//         if  (data.lender_address) orderEditData.lender_address = data.lender_address;
//         if (data.product_type) orderEditData.product_type = data.product_type;
//         if (data.apn) orderEditData.apn = data.apn;
//         // borrower fields
//         orderEditData.borrower_name = data.borrower_name;
//         orderEditData.is_same_asowner = data.is_same_asowner;
//         // whole adddress
//         if  (data.address) orderEditData.address = data.address;
//         // For the owners array, the API likely expects the entire new array
//         if (data.owners) orderEditData.owners = data.owners;

//         const response = await fetch(`${API_URL}/orders/${data.order_id}/`,{
//             method:'PATCH',
//             headers:{
//                 "Content-Type": "application/json",
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(orderEditData)
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Editing orders failed");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("Error while editing the order data", error?.data || error.message)
//         throw error;
//     }
// }

// Helper for sending the edit request
async function attemptEditOrder(data, token) {
  const orderEditData = {};
  if (data.file_num) orderEditData.file_num = data.file_num;
  if (data.loan_number) orderEditData.loan_number = data.loan_number;
  if (data.client_name) orderEditData.client_name = data.client_name;
  if (data.lender_contact) orderEditData.lender_contact = data.lender_contact;
  if (data.lender_address) orderEditData.lender_address = data.lender_address;
  if (data.product_type) orderEditData.product_type = data.product_type;
  if (data.apn) orderEditData.apn = data.apn;
  if (data.address) orderEditData.address = data.address;
  if (data.owners) orderEditData.owners = data.owners;

  // Required fields (even if null/false)
  orderEditData.borrower_name = data.borrower_name;
  orderEditData.is_same_asowner = data.is_same_asowner;

  const response = await fetch(`${API_URL}/orders/${data.order_id}/`, {
    method: 'PATCH',
    headers: {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(orderEditData),
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error("Editing orders failed");
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// Main function
export async function editOrder(data) {
  let accessToken = JSON.parse(localStorage.getItem('accessToken'));

  try {
    return await attemptEditOrder(data, accessToken);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken(); // defined elsewhere
        return await attemptEditOrder(data, newAccessToken);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError.message);
        throw refreshError;
      }
    }

    console.log("Error while editing the order data", error?.data || error.message);
    throw error;
  }
}

// change status
// export async function statusUpdate(data) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/update_status/`,{
//             method:"POST",
//             headers:{
//                 "Content-Type": "application/json",
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(data)
//         })

//         const responseData = await response.json()

//         if(!response.ok){
//             const err = new Error("Updating Status failed");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("Error occurred while updating the status",error?.data ||  error.message)
//         throw error;
//     } 
// }

// Helper for sending the status update request
async function attemptStatusUpdate(data, token) {
    const response = await fetch(`${API_URL}/update_order_status/`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data)
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error("Updating Status failed");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main function
export async function statusUpdate(data) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
        return await attemptStatusUpdate(data, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken();
                return await attemptStatusUpdate(data, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while updating the status", error?.data || error.message);
        throw error;
    }
}


// bulk order api
// export async function bulkOrder(file) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'));

//         const formData = new FormData()
//         formData.append('file', file)

//         const response = await fetch(`${API_URL}/bulk_order/`,{
//             method:'POST',
//             headers:{
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: formData
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Bulk order upload failed");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData
//     }catch(error){
//         console.log("Error occurred while creating bulk order",error?.data ||  error.message)
//         throw error;
//     }
// }

// Helper for sending the bulk order request
async function attemptBulkOrder(file, token) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API_URL}/bulk_order/`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        },
        body: formData
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error(responseData?.message || "Bulk order upload failed");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main function
export async function bulkOrder(file) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
        return await attemptBulkOrder(file, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken();
                return await attemptBulkOrder(file, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error occurred while creating bulk order", error?.data || error.message);
        throw error;
    }
}

// change status after generation of final report
// Helper for sending the status update request
async function attemptFinalStatusUpdate(data, token) {
    const response = await fetch(`${API_URL}/update_order_final/?order_id=${data}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
        }
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error("Updating Status failed");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main function
export async function statusUpdateAfterReportGeneration(data) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
        return await attemptFinalStatusUpdate(data, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken();
                return await attemptFinalStatusUpdate(data, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while updating the status", error?.data || error.message);
        throw error;
    }
}